import { ILegalTransactionRecordNumber } from '../Interfaces/ILegalTransactionRecordNumber';

/**
 * Filtert die unbewerteten Urkunden (#1186) nach einem Suchbegriff.
 * Gesucht wird per case-insensitivem Teilstring über das Aktenzeichen
 * (`RecordNumberEntry`) und die Vorgangsnummer (`idLegalTransaction`).
 * Ein leerer bzw. reiner Whitespace-Suchbegriff liefert alle Zeilen.
 */
export const filterUnassignedRecordNumbers = (
  rows: ILegalTransactionRecordNumber[],
  searchTerm: string
): ILegalTransactionRecordNumber[] => {
  const query = searchTerm.trim().toLocaleLowerCase();
  if (query === '') return rows;

  return rows.filter(row => {
    const aktenzeichen = (row.RecordNumberEntry ?? '').toLocaleLowerCase();
    const vorgangsnummer =
      typeof row.idLegalTransaction === 'number'
        ? String(row.idLegalTransaction)
        : '';
    return aktenzeichen.includes(query) || vorgangsnummer.includes(query);
  });
};
